import React from 'react'

import {
  Icon,
  Text,
  IconVariant,
  Box,
  Color,
  FontSize,
  FontWeight,
  Display,
  FlexDirection,
  AlignItems,
} from '@gousto-internal/citrus-react'

export const BestValueBadge = () => (
  <Box display={Display.Flex} flexDirection={FlexDirection.Row} alignItems={AlignItems.FlexStart}>
    <Icon name="offer_pound" size={5} variant={IconVariant.Confirmation} />
    <Text color={Color.Success_800} size={0 as FontSize} fontWeight={FontWeight.Bold}>
      BEST VALUE
    </Text>
  </Box>
)
